(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["cart-drawer"]) return;
  try {
    
(function () {
  // Cart reservation countdown. Re-queries the DOM each tick so it survives the
  // drawer re-rendering after add-to-cart; the expiry persists across page loads
  // in sessionStorage and resets to 10:00 whenever the cart goes empty.
  var KEY = 'pique:cartReserve', DUR = 600000; // 10 minutes
  function pad(n) { return n < 10 ? '0' + n : '' + n; }
  function tick() {
    var wrap = document.querySelector('[data-cart-timer]');
    var out = wrap && wrap.querySelector('[data-timer-time]');
    if (!wrap || !out) { sessionStorage.removeItem(KEY); return; }
    var now = Date.now();
    var exp = parseInt(sessionStorage.getItem(KEY), 10);
    if (!exp || isNaN(exp)) { exp = now + DUR; sessionStorage.setItem(KEY, String(exp)); }
    var left = exp - now;
    if (left <= 0) { out.textContent = '00:00'; wrap.setAttribute('data-expired', ''); return; }
    wrap.removeAttribute('data-expired');
    out.textContent = pad(Math.floor(left / 60000)) + ':' + pad(Math.floor((left % 60000) / 1000));
  }
  tick();
  setInterval(tick, 1000);
})();

  } catch(e) { console.error(e); }
})();
})();
